import React, { useMemo, useState } from 'react';
import { ListItem } from '@mui/material';

import {
    AcpTokenList,
    ChainId,
    LidoTokenList,
    Token,
    Tokens,
} from '../../constants';

import Loading from '../Loading';
import styled from 'styled-components';
import LidoSVG from '@/assets/images/lido.svg?react';
import useTokenBalance from '@/hooks/use-token-balance';

const StyledListItem = styled(ListItem)`
    height: 64px;
    padding: 12px;
    display: flex;
    flex-flow: row nowrap;
    cursor: pointer;
    box-sizing: border-box;
    margin-bottom: 12px;
    border-radius: 16px;
    background: ${({ theme }) => theme.c.bg04};

    img {
        width: 100%;
        max-width: 40px;
        max-height: 40px;
        border-radius: 50%;
    }

    .tokenItemCon {
        display: flex;
        flex-flow: column wrap;
        width: 90%;
        margin: 0 16px;
    }
    .tokenItemTitle {
        color: ${({ theme }) => theme.c.t01};
        font-weight: 600;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        .tag {
            background-color: #b7b7b7;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 4px;
            background-color: rgba(0, 207, 255, 0.1);

            color: ${({ theme }) => theme.c.t01};
            padding: 0px 8px;
            font-size: 12px;
            font-weight: 400;
            border-radius: 10px;
        }
    }
    .tokenItemDes {
        color: ${({ theme }) => theme.c.t02};
        font-size: 12px;
    }

    .tokenItemCount {
        font-size: 14px;
        font-weight: 600;
        line-height: 28px;
        margin-right: 10px;
        color: ${({ theme }) => theme.c.t01};
    }

    &.tokenDisableItem {
        opacity: 1;
        cursor: not-allowed !important;
    }
`;

const LidoTokenItem = styled(LidoSVG)`
    width: 12px;
    height: 12px;
`;

const ACPTokenItem = styled.img`
    width: 12px !important;
    height: 12px;
`;
interface Props {
    name: Token;
    chainId: ChainId;
    onClick(name: Token): void;
}

export default function TokenInfo({ name, chainId, onClick }: Props) {
    const token = (Tokens[name] as any)[chainId];
    const { balance, loadingOnce } = useTokenBalance(token?.address);

    if (!token) return null;

    const disabled = useMemo(() => {
        return !balance || !balance.toNumber();
    }, [balance]);

    const isLidoToken = useMemo(() => {
        return LidoTokenList.filter((item) => item === name).length > 0;
    }, [name]);

    const isACPToken = useMemo(() => {
        return AcpTokenList.filter((item) => item === name).length > 0;
    }, [name]);

    return (
        <>
            <StyledListItem
                onClick={() => {
                    if (disabled) return;
                    onClick(name);
                }}
                className={disabled ? 'tokenDisableItem' : ''}
            >
                <img src={token.img} />
                <div className="tokenItemCon">
                    <div className="tokenItemTitle">
                        {token.symbol}{' '}
                        {isLidoToken && (
                            <div className="tag">
                                <LidoTokenItem />
                                Lido Multichain
                            </div>
                        )}
                        {isACPToken && (
                            <div className="tag">
                                <ACPTokenItem
                                    src={require('../../assets/images/acp.jpg')}
                                />
                                Issued by Arena of Faith
                            </div>
                        )}
                    </div>
                    <div className="tokenItemDes">{token.name}</div>
                </div>
                <div className="tokenItemCount">
                    {!loadingOnce && balance.eq(0) ? (
                        <Loading style={{ color: '#fff' }} />
                    ) : (
                        Number(balance.toFixed(8, 1))
                    )}
                </div>
            </StyledListItem>
        </>
    );
}
